"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const CheckBox_1 = require("./CheckBox");
const Icon_1 = __importDefault(require("./Icon"));
exports.TableHeader = react_1.default.memo(({ allChecked, titleFontClass, styles, showCheckBox, showIndex, headTitleList, sort, desc, handlerUpdateSort, handlerCheck, tableOption, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const renderHeadItem = (0, react_1.useMemo)(() => {
        return headTitleList.map((item, index) => {
            const isSorted = item.sort && item.title === sort;
            const rotation = isSorted
                ? desc
                    ? 'rotate(90deg)'
                    : 'rotate(270deg)'
                : 'rotate(90deg)';
            return (react_1.default.createElement("div", { key: item.title + index, className: `table-header-item head-${item.title}`, style: {
                    ...styles?.headItem,
                    ...item?.styles,
                    cursor: item.sort ? 'pointer' : 'default',
                    flex: item.space,
                    maxWidth: item?.maxWidth ? item.maxWidth : 'auto',
                    minWidth: item?.minWidth ? item.minWidth : 'unset',
                    flexDirection: item.children ? 'column' : 'row',
                    ...(item.maxWidth && { maxWidth: item.maxWidth }),
                }, onClick: item.sort ? () => handlerUpdateSort(item.title) : undefined },
                react_1.default.createElement("div", { className: "text" },
                    react_1.default.createElement("p", { className: "overText2", style: styles?.headText }, item.label ?? t(`table.${item.title}`)),
                    item.sort && (react_1.default.createElement(Icon_1.default, { style: {
                            transform: rotation,
                        }, icon: "arrow", size: tableOption.sortIcon.size, stroke: tableOption.sortIcon.color }))),
                item.children && (react_1.default.createElement("div", { className: "table-header-child", style: { width: '100%' } }, item.children.map(i => (react_1.default.createElement("p", { key: i, style: { flex: 1 } }, i)))))));
        });
    }, [headTitleList, sort, desc]);
    return (react_1.default.createElement("div", { className: `table-header ${titleFontClass}`, style: styles?.headWrapper },
        showCheckBox && (react_1.default.createElement("div", { className: "table-header-item", style: { ...styles?.headItem, minWidth: 30 } },
            react_1.default.createElement(CheckBox_1.CheckBoxElement, { id: "all", iconSize: 22, checked: allChecked, handlerCheck: handlerCheck }))),
        showIndex && (react_1.default.createElement("div", { className: "table-header-item", style: { ...styles?.headItem, minWidth: 45, maxWidth: 60 } },
            react_1.default.createElement("p", { style: styles?.headText },
                " ",
                t('table.no')))),
        renderHeadItem));
});
